import React from 'react';
import FormLoginBasic from '../Form/FormLoginBasic';
import { TbUserQuestion } from 'react-icons/tb';

interface LoginBasicProps {
  onClose: CallableFunction;
}

const LoginBasic = ({onClose}: LoginBasicProps) => {
  
  return (
    <div className="flex flex-col">

        <div className='flex flex-row w-full items-center gap-2 p-3 py-4'>
          <span><TbUserQuestion size={40} className='fadeInIcon' /></span>
          <div className='grid text-left'>
            <h2 className='text-2xl font-extrabold leading-none'>Sobre você...</h2>
            <p className='text-gray-600 leading-none'>Precisamos de poucas informações</p>
          </div>
        </div>

        <FormLoginBasic onCancel={() => onClose()} />

    </div>
  )
}

export default LoginBasic;